import { RadioGroup, TextArea } from "devextreme-react";
import { DataItem, HCostData } from "@constants/inbound";
import { useAtomValue } from "jotai";
import { hcostInboundAtom } from "@/store/hcost-atom";
import useCounselHook from "@feature/counsel/useCounselHook";

const CounselAddInfo = () => {
  const hCostResult = useAtomValue(hcostInboundAtom);
  const { onValueChangeCounselHandler } = useCounselHook();

  return (
    <>
      {/*추가 정보*/}
      <div className="content-fieldset">
        <h3 className="content-fieldset-title">추가 정보</h3>
        <div className="content-fieldset-title-desc" />

        <div className="content-field row">
          <div className="content-field-label">
            <div className="content-label-name">요청 사항</div>
            <div className="content-label-desc" />
          </div>
          <div className="content-field-value full">
            <TextArea
              height="120"
              maxLength="2000"
              value={hCostResult.counselMemo}
              onValueChanged={onValueChangeCounselHandler((draft, value) => {
                draft.counselMemo = value;
              })}
            />
            <div className="content-value-desc" />
          </div>
        </div>

        <div className="content-field row ">
          <div className="content-field-label">
            <div className="content-label-name">거래 방식</div>
            <div className="content-label-desc" />
          </div>
          <div className="content-field-value full flex">
            <RadioGroup
              items={HCostData.transactionMethod.items}
              displayExpr="value"
              layout="horizontal"
              valueExpr="code"
              value={hCostResult.transactionMethod?.code}
              onValueChanged={onValueChangeCounselHandler((draft, value) => {
                const values = HCostData.transactionMethod.items.find((v: DataItem) => v.code === value);
                draft.transactionMethod = values || null;
              })}
            />

            <div className="content-value-desc" />
          </div>
        </div>

        <div className="content-field row">
          <div className="content-field-label">
            <div className="content-label-name">농사 경력</div>
            <div className="content-label-desc" />
          </div>
          <div className="content-field-value full">
            <RadioGroup
              items={HCostData.conFarmingV2.items}
              value={hCostResult.conFarming}
              displayExpr="text"
              layout="horizontal"
              valueExpr="text"
              width="100%"
              onValueChanged={onValueChangeCounselHandler((draft, value) => {
                draft.conFarming = value;
              })}
            />
            <div className="content-value-desc" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CounselAddInfo;
